import { useState } from 'react';
import { Link, Copy, CheckCircle2 } from 'lucide-react';

export default function URLTool() {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [copied, setCopied] = useState(false);

  const encode = () => {
    setOutput(encodeURIComponent(input));
  };

  const decode = () => {
    try {
      setOutput(decodeURIComponent(input));
    } catch {
      setOutput('Invalid URL encoded string');
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(output);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-gradient-to-br from-gray-50 to-white dark:from-dark-bg dark:to-dark-surface rounded-2xl p-6 border-2 border-gray-200 dark:border-dark-border shadow-lg">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-gradient-to-br from-coral-500 to-teal-500 rounded-xl shadow-lg">
          <Link className="w-5 h-5 text-white" />
        </div>
        <div>
          <h2 className="text-lg font-bold text-gray-900 dark:text-dark-text">URL Encoder/Decoder</h2>
          <p className="text-sm text-gray-500 dark:text-dark-muted">Encode or decode URL strings</p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="text-xs font-semibold text-gray-600 dark:text-gray-400 mb-2 block">
            Input
          </label>
          <textarea
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Enter text to encode or URL encoded string to decode..."
            className="w-full h-96 p-3 border border-gray-300 dark:border-gray-600 rounded-lg font-mono text-xs bg-white dark:bg-dark-bg text-gray-900 dark:text-dark-text focus:outline-none focus:ring-2 focus:ring-coral-400 focus:border-transparent resize-none transition-all"
          />
          <div className="flex gap-2 mt-2">
            <button
              onClick={encode}
              className="flex-1 px-4 py-2 bg-gradient-to-r from-coral-500 to-pink-500 text-white rounded-lg text-sm font-medium hover:shadow-lg transition-all"
            >
              Encode
            </button>
            <button
              onClick={decode}
              className="flex-1 px-4 py-2 bg-gradient-to-r from-teal-500 to-blue-500 text-white rounded-lg text-sm font-medium hover:shadow-lg transition-all"
            >
              Decode
            </button>
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-2">
            <label className="text-xs font-semibold text-gray-600 dark:text-gray-400">
              Output
            </label>
            {output && (
              <button
                onClick={copyToClipboard}
                className="p-1.5 hover:bg-gray-100 dark:hover:bg-dark-border rounded transition-colors"
              >
                {copied ? (
                  <CheckCircle2 className="w-4 h-4 text-green-600" />
                ) : (
                  <Copy className="w-4 h-4 text-gray-600 dark:text-gray-400" />
                )}
              </button>
            )}
          </div>
          <textarea
            value={output}
            readOnly
            placeholder="Encoded or decoded URL will appear here..."
            className="w-full h-96 p-3 border border-gray-300 dark:border-gray-600 rounded-lg font-mono text-xs bg-gray-50 dark:bg-dark-bg text-gray-900 dark:text-dark-text resize-none break-all"
          />
        </div>
      </div>
    </div>
  );
}
